import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-767f83fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "header-item" }
const _hoisted_3 = { class: "header-item" }
const _hoisted_4 = { class: "header-item" }
const _hoisted_5 = { class: "pagination" }

import { onMounted, ref, watch } from 'vue'
import { getResDetail } from '@/api/common'
import { ERR_SUCCESS } from '@/api/config'
import StorageDetail from '@/components/resource/detail.vue'
import bus from '@/utils/bus'
import { useRouter } from 'vue-router'

interface ResourceInterface {
  id: string;
  title: string;
  ceci_name: string;
  course_name: string;
  ceci_id: string | number;
  course_id: string | number;
}

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceStorage',
  props: {
    resource: {}
  },
  setup(__props: any) {

const datalist = ref<any[]>([])
const currentPage = ref<number>(1)
const pageSize = ref<number>(10)
const totalSize = ref<number>(0)
const searchKeyword = ref('')
const router = useRouter()

const props = __props

function mergeAndFilterByFormat (data: any[], excludeFormats: string[]) {
  const mergedResult: Record<string, Set<string>> = {}

  data.forEach(item => {
    const { format, storages } = item

    // Check if the format is in the exclude list
    if (!excludeFormats.includes(format)) {
      if (!mergedResult[format]) {
        mergedResult[format] = new Set()
      }

      // Merge the URLs, using Set to automatically handle duplicates
      storages.split(',').forEach((url: string) => {
        mergedResult[format].add(url)
      })
    }
  })

  // Convert the sets back into arrays for the final output
  return Object.keys(mergedResult).map(format => ({
    [format]: Array.from(mergedResult[format])
  }))
}

async function fetchData () {
  try {
    const { code, result: { items: data = [], total = 0 } = {} } = await getResDetail(props.resource.id)
    if (code === ERR_SUCCESS && data) {
      // Example usage:
      const excludeFormats = ['folder']

      datalist.value = mergeAndFilterByFormat(data, excludeFormats) // Assign merged and cleaned data to the datalist
      totalSize.value = total
    }
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

bus.on('keywordChange', (event) => {
  searchKeyword.value = event as string
  fetchData()
})

const gotoCeci = () => {
  router.push({
    name: 'CourseDetail',
    params: { id: props.resource.ceci_id }
  })
}

const gotoCourse = () => {
  router.push({
    name: 'ResourceDetail',
    params: { id: props.resource.course_id }
  })
}

onMounted(() => fetchData())

watch(() => props.resource.id, fetchData)
watch(searchKeyword, () => fetchData())
watch([currentPage, pageSize], fetchData)


return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_text, { type: "info" }, {
            default: _withCtx(() => [
              _createTextVNode("课程名称：")
            ]),
            _: 1
          }),
          _createVNode(_component_el_text, { truncated: "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.resource.course_name), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_text, { type: "info" }, {
            default: _withCtx(() => [
              _createTextVNode("资源名称：")
            ]),
            _: 1
          }),
          _createVNode(_component_el_text, { truncated: "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.resource.title), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_text, { type: "info" }, {
            default: _withCtx(() => [
              _createTextVNode("所属册次：")
            ]),
            _: 1
          }),
          _createVNode(_component_el_text, { truncated: "" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.resource.ceci_name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "right-button",
            size: "small",
            type: "primary",
            onClick: gotoCeci
          }, {
            default: _withCtx(() => [
              _createTextVNode("同册资源")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(StorageDetail, { data: datalist.value }, null, 8, ["data"]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageSize).value = $event)),
        "hide-on-single-page": true,
        "page-sizes": [12, 24, 36, 48, 60],
        total: totalSize.value,
        layout: "pager",
        "next-text": "下一页",
        "prev-text": "上一页",
        small: ""
      }, null, 8, ["current-page", "page-size", "total"])
    ])
  ]))
}
}

})